module.exports = __webpack_public_path__ + "static/image-03-b@2x-dcf08317fbcfaf1da4d973c1b2e0dfdb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/hudl/image-03-b@2x.jpg
// module id = 381
// module chunks = 3627797113349 20562973939449 33019919093843